import { useCallback, useState, useEffect } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';

export function HubSpotChatButton() {
  const [tooltipTitle, setTooltipTitle] = useState(sessionStorage.getItem('hubspotChatOpen') === 'true' ? 'Close chat' : 'Chat with us!');

  useEffect(() => {
    if (!window.location.search.includes('openChat=true')) return;

    sessionStorage.setItem('hubspotChatOpen', 'true');
    setTooltipTitle('Close chat');

    const openChat = () => {
      const widget = window.HubSpotConversations?.widget;
      if (!widget) return;

      if (widget.status().loaded) {
        widget.open();
      } else {
        widget.load({ widgetOpen: true });
      }
    };

    if (window.HubSpotConversations) {
      openChat();
    } else {
      window.hsConversationsOnReady = [...(window.hsConversationsOnReady ?? []), openChat];
    }
  }, []);

  const handleChatClick = useCallback(() => {
    const widget = window.HubSpotConversations?.widget;

    function showChat(show: boolean) {
      if (!widget) return;

      if (show) {
        widget.open();
      } else {
        widget.remove();
      }
    }

    function handleChat(opening: boolean) {
      if (!widget) return;

      if (widget.status().loaded) {
        showChat(opening);
      } else {
        widget.load();
        const interval = setInterval(() => {
          if (widget?.status().loaded) {
            clearInterval(interval);
            showChat(opening);
          }
        }, 100);
      }
    }

    const isOpen = sessionStorage.getItem('hubspotChatOpen') === 'true';
    if (isOpen) {
      sessionStorage.removeItem('hubspotChatOpen');
      setTooltipTitle('Chat with us!');
    } else {
      sessionStorage.setItem('hubspotChatOpen', 'true');
      setTooltipTitle('Close chat');
    }

    handleChat(!isOpen);
  }, []);

  return (
    <Tooltip title={tooltipTitle} placement='bottom'>
      <IconButton color='default' aria-label='Show/Hide chat' size='small' onClick={handleChatClick}>
        <ChatIcon />
      </IconButton>
    </Tooltip>
  );
}
